export default {
  // 登录页
  '主播开播管理': '主播开播管理',
  '请输入手机号': '请输入手机号',
  '请输入手机验证码': '请输入手机验证码',
  '请输入图形验证码': '请输入图形验证码',
  '登录': '登录',
  '登录成功': '登录成功',
  '登录失败': '登录失败',

  // 侧边栏菜单
  '直播设置': '直播设置',
  '节目管理': '节目管理',
  '房间管理': '房间管理',
  '禁言设置': '禁言设置',
  '我的收益': '我的收益',
  '我的粉丝团': '我的粉丝团',
  '抽奖': '抽奖',
  '趣猜': '趣猜',

  // 直播设置页
  '直播间标题': '直播间标题',
  '房间ID': '房间ID',
  '直播间封面': '直播间封面',
  '未设置': '未设置',
  '直播间公告': '直播间公告',
  '直播窗口公告': '直播窗口公告',
  '分钟轮播一次': '分钟轮播一次',
  '去编辑': '去编辑',
  '去直播': '去直播',
  '点击修改': '点击修改',
  '上传封面': '上传封面',
  '建议图片尺寸为： 750像素*426像素。支持jpg、png图片': '建议图片尺寸为： 750像素*426像素。支持jpg、png图片',
  '选择公告展示区域': '选择公告展示区域',
  '暂无数据': '暂无数据',
  '请输入您的直播间公告内容': '请输入您的直播间公告内容',
  '备注：手机端遵循以上设置展示，电脑端始终在主播页面展示': '备注：手机端遵循以上设置展示，电脑端始终在主播页面展示',
  '公告区域': '公告区域',
  '全部展示（个人主页和直播视频下方）': '全部展示（个人主页和直播视频下方）',
  '仅在个人主页展示公告': '仅在个人主页展示公告',
  '选择公告轮播频率': '选择公告轮播频率',
  '可输入引导加入粉丝群、推荐爆料等信息': '可输入引导加入粉丝群、推荐爆料等信息',
  '备注：设定后直播窗口会以固定的频率播放此公告内容': '备注：设定后直播窗口会以固定的频率播放此公告内容',
  '保存': '保存',
  '返回': '返回',
  '您的直播间已被禁用，请联系客服!': '您的直播间已被禁用，请联系客服!',
  '图片格式：仅支持png、jpg': '图片格式：仅支持png、jpg',
  '确认': '确认',
  '请输入直播间标题': '请输入直播间标题',
  '保存成功': '保存成功',

  // 5 分钟轮播选项
  '分钟轮播一次': '分钟轮播一次',

  // 赛程页面
  '热门比赛': '热门比赛',
  '今日': '今日',
  '场比赛': '场比赛',
  '收起': '收起',
  '展开': '展开',
  '今天': '今天',
  '比赛中': '比赛中',
  '加时': '加时',
  '点球': '点球',
  '比赛推迟': '比赛推迟',
  '未开始': '未开始',
  '已结束': '已结束',
  '进行中': '进行中',
  '已添加': '已添加',
  '添加计划': '添加计划',
  '暂无即将开始的比赛！': '暂无即将开始的比赛！',
  '您确定要取消本场直播计划吗？': '您确定要取消本场直播计划吗？',
  '赛事名称': '赛事名称',
  '主客队': '主客队',
  '比赛时间': '比赛时间',
  '直播时间': '直播时间',
  '取消直播': '取消直播',
  '设置直播时间': '设置直播时间',
  '已取消计划': '已取消计划',
  '已加入直播计划': '已加入直播计划',
  '网络连接失败，请检查您的网络！': '网络连接失败，请检查您的网络！',
  '全部': '全部',
  '赛程': '赛程',
  '积分榜': '积分榜',
  '射手榜': '射手榜',
  '助攻榜': '助攻榜',
  '排行榜': '排行榜',
  '球队榜': '球队榜',
  '球员榜': '球员榜',
  '开始日期': '开始日期',
  '结束日期': '结束日期',

  // 房管设置页
  '房管设置': '房管设置',
  '添加房管': '添加房管',
  '所属平台': '所属平台',
  '用户昵称': '用户昵称',
  '任命时间': '任命时间',
  '操作': '操作',
  '撤销': '撤销',
  '您确定要撤销此房管？': '您确定要撤销此房管？',
  '请选择所属平台': '请选择所属平台',
  '请输入昵称': '请输入昵称',
  '请选择平台': '请选择平台',
  '自己不可以被添加为房管': '自己不可以被添加为房管',
  '已撤销': '已撤销',
  '已添加': '已添加',
  '添加房管': '添加房管',
  '撤销房管': '撤销房管',

  // 节目管理页
  '直播节目': '直播节目',
  '历史记录': '历史记录',
  '新增直播': '新增直播',
  '新增直播节目': '新增直播节目',
  '请选择直播赛事': '请选择直播赛事',
  '请选择赛事': '请选择赛事',
  '请选择比赛时间': '请选择比赛时间',
  '查询': '查询',
  '类型': '类型',
  '直播计划时间': '直播计划时间',
  '赛事': '赛事',
  '主客队/节目名称': '主客队/节目名称',
  '正在直播': '正在直播',
  '开始直播': '开始直播',
  '结束直播': '结束直播',
  '修改': '修改',
  '取消': '取消',
  '正在为你生成直播流地址，建议您配置好OBS后开始直播': '正在为你生成直播流地址，建议您配置好OBS后开始直播',
  '建议您先设置OBS停止推流后结束直播，如果您已设置请忽略': '建议您先设置OBS停止推流后结束直播，如果您已设置请忽略',
  '填写节目名称': '填写节目名称',
  '修改直播时间': '修改直播时间',
  '直播间名称': '直播间名称',
  '直播内容': '直播内容',
  '比赛流地址': '比赛流地址',
  '暂无比赛流地址，请稍后再试': '暂无比赛流地址，请稍后再试',
  '刷新': '刷新',
  '复制': '复制',
  '服务器': '服务器',
  '串流密钥': '串流密钥',
  '未获取到比赛流地址，请稍后再试': '未获取到比赛流地址，请稍后再试',
  '已复制': '已复制',

  // 趣猜页面
  '趣猜': '趣猜',
  '趣猜列表': '趣猜列表',
  '历史记录': '历史记录',
  '玩法介绍': '玩法介绍',
  '发起趣猜': '发起趣猜',
  '趣猜主题': '趣猜主题',
  '趣猜选项': '趣猜选项',
  '投注人数': '投注人数',
  '投注金额': '投注金额',
  '赔率': '赔率',
  '结账时间': '结账时间',
  '趣猜结果': '趣猜结果',
  '主播佣金': '主播佣金',
  '出题时间': '出题时间',
  '状态': '状态',
  '操作': '操作',
  '已停止': '已停止',
  '结账': '结账',
  '选择胜利方选项': '选择胜利方选项',
  '流局（以上都不是）': '流局（以上都不是）',
  '确定': '确定',
  '返回': '返回',
  '趣猜结账': '趣猜结账',
  '请输入趣猜题目': '请输入趣猜题目',
  '选项一': '选项一',
  '请输入趣猜选项': '请输入趣猜选项',
  '选项二': '选项二',
  '持续时间': '持续时间',
  '选择趣猜投注时间范围': '选择趣猜投注时间范围',
  '确认发起': '确认发起',
  '网络连接失败，请检查您的网络！': '网络连接失败，请检查您的网络！',
  '请输入趣猜主题': '请输入趣猜主题',
  '已成功发起趣猜': '已成功发起趣猜',
  '流局': '流局',
  '趣猜玩法介绍': '趣猜玩法介绍',
  '已绑定手机': '已绑定手机',
  '您可以享受手机相关的安全服务': '您可以享受手机相关的安全服务',
  '新昵称': '新昵称',
  '请输入新的昵称': '请输入新的昵称',
  '昵称最多10个字符，30天内只能修改一次': '昵称最多{number}个字符，30天内只能修改一次',
  '基本资料': '基本资料',
  '修改昵称': '修改昵称',
  '修改昵称成功': '修改昵称成功',
  '备注': '备注',

  // 收益页面
  '金币收益': '金币收益',
  '钻石收益': '钻石收益',
  '收益类型': '收益类型',
  '详情': '详情',
  '完成时间': '完成时间',
  '金币记录': '金币记录',
  '钻石记录': '钻石记录',
  '请选择时间': '请选择时间',

  // 粉丝页面
  '您还没开通粉丝团？': '您还没开通粉丝团？',
  '立即申请': '立即申请',
  '您提交的申请正在审核中，请耐心等待！': '您提交的申请正在审核中，请耐心等待！',
  '抱歉！您的申请已被驳回，请联系客服！': '抱歉！您的申请已被驳回，请联系客服！',
  '申请粉丝团': '申请粉丝团',
  '修改徽章名称': '修改徽章名称',
  '徽章名称': '徽章名称',
  '请输入粉丝徽章名称': '请输入粉丝徽章名称',
  '确认申请': '确认申请',
  '确认修改': '确认修改',
  '全部直播平台': '全部直播平台',
  '团成员': '团成员',
  '本周新成员': '本周新成员',
  '本周亲密度': '本周亲密度',
  '粉丝徽章名称': '粉丝徽章名称',

  // 禁言设置页
  '禁言设置': '禁言设置',
  '请输入用户昵称': '请输入用户昵称',
  '请选择禁言时间': '请选择禁言时间',
  '禁言时间': '禁言时间',
  '用户头像': '用户头像',
  '解禁时间': '解禁时间',
  '解除禁言': '解除禁言',
  '确定要取消禁言？': '确定要取消禁言？',
  '已取消禁言': '已取消禁言',
  '取消禁言': '取消禁言',

  // 抽奖页面
  '抽奖记录': '抽奖记录',
  '抽奖规则': '抽奖规则',
  '中奖名单': '中奖名单',
  '开启抽奖': '开启抽奖',
  '抽奖类型': '抽奖类型',
  '奖品份数': '奖品份数',
  '抽取规则': '抽取规则',
  '面向用户': '面向用户',
  '开启时间': '开启时间',
  '弹幕抽奖': '弹幕抽奖',
  '送礼抽奖': '送礼抽奖',
  '人数': '人数',
  '人次': '人次',
  '全部用户': '全部用户',
  '关注用户': '关注用户',
  '粉丝团用户': '粉丝团用户',
  '等级用户': '等级用户',
  '未知用户': '未知用户',
  '用户等级': '用户等级',
  '级': '级',
  '金币': '金币',
  '兑换券': '兑换券',
  '请输入每份奖品金币数量': '请输入每份奖品金币数量',
  '请选择兑换卷奖品': '请选择兑换卷奖品',
  '请输入奖品份数': '请输入奖品份数',
  '如主播666': '如主播666',
  '请输入送礼数量': '请输入送礼数量',
  '本月抽奖专用剩余金币': '本月抽奖专用剩余金币',
  '本月抽奖专用剩余兑换券': '本月抽奖专用剩余兑换券',
  '级': '级',
  '已成功开启抽奖': '已成功开启抽奖',
  '不能同时开启多个抽奖活动': '不能同时开启多个抽奖活动',
  '请输入抽奖金额': '请输入抽奖金额',
  '请输入指定弹幕': '请输入指定弹幕',
  '个月': '个月',
  '已删除': '已删除',
  '已下架': '已下架',
  '已上架': '已上架',
  '已过期': '已过期',
  '未生效': '未生效',
  '中奖率与发送弹幕数量无关': '中奖率与发送弹幕数量无关',
  '中奖率与送礼物数量无关': '中奖率与送礼物数量无关',
  '送礼越多，中奖率越高': '送礼越多，中奖率越高',
  '分钟': '分钟',
  '小时': '小时',
  '人人体育': '人人体育',
  '88直播': '88直播',
  '看球直播': '看球直播',
  '比赛直播': '比赛直播',
  '直播时间': '直播时间',
  '确认': '确认',
  '填写节目名称': '填写节目名称',
  '足球': '足球',
  '篮球': '篮球',
  '网球': '网球',
  '乒乓球': '乒乓球',
  '台球': '台球',
  '羽毛球': '羽毛球',
  '其他赛事': '其他赛事',
  '娱乐直播': '娱乐直播',
  '主客队/节目名称': '主客队/节目名称',
  '状态': '状态',
  '结账成功': '结账成功',
  '注': '注',

  // 聊天室页面
  '请选择举报类型': '请选择举报类型',
  '提交': '提交',
  '彩色弹幕': '彩色弹幕',
  '暂无hot词！': '暂无hot词！',
  '举报': '举报',
  '撤回消息': '撤回消息',
  '访问网址': '访问网址',
  '是否撤回该聊天消息？': '是否撤回该聊天消息？',
  '取消': '取消',
  '确认撤回': '确认撤回',
  '解除禁言': '解除禁言',
  '禁言': '禁言',
  '禁言吗？': '禁言吗？',
  '确定要将': '确定要将',
  '您的网络状态不好,请重试': '您的网络状态不好,请重试！',
  '连击': '连击',
  '有更多新的消息': '有更多新的消息',
  '屏蔽消息/特效': '屏蔽消息/特效',
  '屏蔽进场消息': '屏蔽进场消息',
  '屏蔽礼物消息': '屏蔽礼物消息',
  '屏蔽礼物特效': '屏蔽礼物特效',
  '发送': '发送',
  '快来唠两句呗~': '快来唠两句呗~',

  // 直播内容页面
  '粉丝': '粉丝',
  '正在加载...': '正在加载...',
  '时': '时',
  '分': '分',
  '秒': '秒',
  '直播间被禁播，正在整顿中...': '直播间被禁播，正在整顿中...',
  '点击取消静音': '点击取消静音',
  '剧场模式': '剧场模式',
  '退出剧场': '退出剧场',
  '全屏模式': '全屏模式',
  '退出全屏': '退出全屏',
  '添加': '添加',
  '节目名称': '节目名称',
  '送': '送',

  // 弹幕设置组件
  '弹': '弹',
  '弹幕设置': '弹幕设置',
  '弹幕模式': '弹幕模式',
  '弹幕字号': '弹幕字号',
  '弹幕透明度': '弹幕透明度',
  '无': '无',
  '精简': '精简',
  '华丽': '华丽',
  '小': '小',
  '中': '中',
  '大': '大',

  // 页面头部组件
  '开播管理': '开播管理',
  '首页': '首页',
  '赛程': '赛程',
  '退出': '退出',
  '已加入直播平台': '已加入直播平台',
  '天': '天',
  '我的钱包': '我的钱包',
  '修改头像': '修改头像',
  '退出成功': '退出成功',
  '修改头像成功': '修改头像成功',

  '主播休息中': '主播休息中',
  '周': '周',
  '时间': '时间',
  '足球': '足球',
  '篮球': '篮球',
  '网球': '网球',
  '乒乓球': '乒乓球',
  '台球': '台球',
  '羽毛球': '羽毛球',
  '电竞': '电竞',
  '其他': '其他',
  '更多数据': '更多数据',
  '距离比赛开始还有': '距离比赛开始还有',
  '修改成功': '修改成功',
  '修改失败': '修改失败',
  '弹幕互动': '弹幕互动',
  '欢迎来到': '欢迎来到',
  '直播间': '直播间',
  '聊天室提倡并监控文明的聊天环境': '聊天室提倡并监控文明的聊天环境',
  '对于违规者账号封禁处理': '对于违规者账号封禁处理',
  '威胁辱骂': '威胁辱骂',
  '色情骚扰': '色情骚扰',
  '垃圾广告': '垃圾广告',
  '暴力血腥': '暴力血腥',
  '违法行为': '违法行为',
  '其他': '其他',
  '网络连接异常，正在重连直播间': '网络连接异常，正在重连直播间',
  '网络连接失败，请检查您的网络！': '网络连接失败，请检查您的网络！',
  '连接成功': '连接成功',
  '举报成功': '举报成功',
  '撤回成功': '撤回成功',
  '禁言成功': '禁言成功',
  '主播不可参与投注趣猜题目': '主播不可参与投注趣猜题目。',
  '每场趣猜题目结束后，会从趣猜用户总奖池中扣除': '每场趣猜题目结束后，会从趣猜用户总奖池中扣除',
  '金额作为给出题主播奖励': '金额作为给出题主播奖励。',
  '若出现不可抗力导致题目关闭，均被判为流局，所有用户的投注金额将全额返还': '若出现不可抗力导致题目关闭，均被判为流局，所有用户的投注金额将全额返还。',
  '若主播忘记结账，题目将在12小时后自动判为流局，所有用户的投注金额将全额返还': '若主播忘记结账，题目将在12小时后自动判为流局，所有用户的投注金额将全额返还。',
  '如果在结账时，有一个或两个选项没有任何人投注，或所有选项都非正确选项，则本题目会判为流局': '如果在结账时，有一个或两个选项没有任何人投注，或所有选项都非正确选项，则本题目会判为流局。',
  '若主播结账错误，用户或主播请第一时间联系客服申诉并提供相关截图。官方会根据多方渠道进行核实': '若主播结账错误，用户或主播请第一时间联系客服申诉并提供相关截图。官方会根据多方渠道进行核实。',
  '确认情况属实，会进行重审或补发奖励，并对主播进行处罚': '确认情况属实，会进行重审或补发奖励，并对主播进行处罚。',
  '趣猜是指主播发起一道竞答题目并设置题目和选项，观众可以在选项之间竞答，当主播确认了竞答结果后，胜利的一方将会分摊失败的一方的投注金额（如下图）': '趣猜是指主播发起一道竞答题目并设置题目和选项，观众可以在选项之间竞答，当主播确认了竞答结果后，胜利的一方将会分摊失败的一方的投注金额（如下图）。',
  '点击你要支持的选项，选择或输入投注金额后点击提交即可': '点击你要支持的选项，选择或输入投注金额后点击提交即可。',
  '每场趣猜题目结束后，会从趣猜用户总奖池中扣除': '每场趣猜题目结束后，会从趣猜用户总奖池中扣除',
  '金额作为给出题主播奖励': '金额作为给出题主播奖励',
  '若奖金金额分配后出现小数，小数后金额向下取整（如三个人分100金币，每个33.3，向下取整后每人发放33金币）': '若奖金金额分配后出现小数，小数后金额向下取整（如三个人分100金币，每个33.3，向下取整后每人发放33金币）。',
  '趣猜每次单场单笔投注金额限制，金币趣猜最小为': '趣猜每次单场单笔投注金额限制，金币趣猜最小为',
  '主播对趣猜结账后，可进入【趣猜记录】查看，趣猜奖励可能存在延迟到账，若长时间未到账请联系客服咨询': '主播对趣猜结账后，可进入【趣猜记录】查看，趣猜奖励可能存在延迟到账，若长时间未到账请联系客服咨询。',
  '若出现不可抗力导致题目关闭，均被判为流局，所有用户的投注金额将全额返还': '若出现不可抗力导致题目关闭，均被判为流局，所有用户的投注金额将全额返还。',
  '若主播忘记结账，题目将在12小时后自动判为流局，所有用户的投注金额将全额返还，主播不可参与趣猜': '若主播忘记结账，题目将在12小时后自动判为流局，所有用户的投注金额将全额返还，主播不可参与趣猜。',
  '特殊情况：如果在趣猜结账时，有一个或两个选项没有任何人投注，或所有选项都非正确选项，则本题目会判为流局': '特殊情况：如果在趣猜结账时，有一个或两个选项没有任何人投注，或所有选项都非正确选项，则本题目会判为流局。',
  '趣猜系统旨在提升用户观看直播体验，仅供娱乐交流使用': '趣猜系统旨在提升用户观看直播体验，仅供娱乐交流使用。',
  '请通过官方渠道获取投注金额，因非正当渠道获取而无法参与趣猜的，用户需自行承担不利后果': '请通过官方渠道获取投注金额，因非正当渠道获取而无法参与趣猜的，用户需自行承担不利后果。',
  '任何影响互动公平性的操作，官方有权取消用户参与主播趣猜资格，并对违规金额进行收回': '任何影响互动公平性的操作，官方有权取消用户参与主播趣猜资格，并对违规金额进行收回。',
  '若有发现违规趣猜，欢迎用户举报': '若有发现违规趣猜，欢迎用户举报',
  '全平台的粉丝徽章名称不能重复（包括审核中的名称）': '全平台的粉丝徽章名称不能重复（包括审核中的名称）',
  '粉丝徽章名称仅支持中文、数字或英文（大小写）': '粉丝徽章名称仅支持中文、数字或英文（大小写）',
  '名称至少为1个字，纯中文不超2个字，只有1个中文时不能超过3个字；不包含中文则不能超过4个字': '名称至少为1个字，纯中文不超2个字，只有1个中文时不能超过3个字；不包含中文则不能超过4个字',
  '粉丝牌名称审核通过后才能生效，不可使用涉政、涉黄、涉暴等敏感词汇，不可使用网络平台专属词汇， 不可使用带有广告意图的词汇；尽量与主播历史常用昵称相关': '粉丝牌名称审核通过后才能生效，不可使用涉政、涉黄、涉暴等敏感词汇，不可使用网络平台专属词汇， 不可使用带有广告意图的词汇；尽量与主播历史常用昵称相关',
  '每30天，主播最多可以修改1次粉丝牌名称': '每30天，主播最多可以修改1次粉丝牌名称',
  '请选择': '请选择',
  '抽奖是本平台提供的直播间互动玩法，由平台提供奖品，用户通过发弹幕或送礼物参与抽奖': '抽奖是本平台提供的直播间互动玩法，由平台提供奖品，用户通过发弹幕或送礼物参与抽奖。',
  '金币奖品抽奖结束后查看金币收益记录，兑换劵奖品抽奖结束后查看兑换券记录': '金币奖品抽奖结束后查看金币收益记录，兑换劵奖品抽奖结束后查看兑换券记录。',
  '抽奖活动由主播发起，并从本平台限定的既有参与方式进行选择。参与抽奖互动功能过程中，用户有权在规定时间内参与抽奖活动': '抽奖活动由主播发起，并从本平台限定的既有参与方式进行选择。参与抽奖互动功能过程中，用户有权在规定时间内参与抽奖活动。',
  '除本平台限定的既有方式外，主播不得自定义中奖规则和任何领奖附加条件，此类附加规则和条件一律无效': '除本平台限定的既有方式外，主播不得自定义中奖规则和任何领奖附加条件，此类附加规则和条件一律无效。',
  '发起的抽奖活动，在抽奖结束后自动陆续发放奖励。如有奖励长时间未到账情况，请联系客服咨询': '发起的抽奖活动，在抽奖结束后自动陆续发放奖励。如有奖励长时间未到账情况，请联系客服咨询。',
  '使用本平台抽奖互动功能举办的抽奖活动，所生成的抽奖结果均有效，且不可撤销、删除、更改': '使用本平台抽奖互动功能举办的抽奖活动，所生成的抽奖结果均有效，且不可撤销、删除、更改。',
  '任何影响互动公平性的操作，官方有权取消用户参与主播抽奖资格，并对违规金额和奖品进行收回': '任何影响互动公平性的操作，官方有权取消用户参与主播抽奖资格，并对违规金额和奖品进行收回。',
  '本活动最终解释权归平台所有。若有发现违规抽奖，欢迎用户举报': '本活动最终解释权归平台所有。若有发现违规抽奖，欢迎用户举报。',
  '奖品类型': '奖品类型',
  '抽奖金额': '抽奖金额',
  '选择奖品': '选择奖品',
  '张': '张',
  '抽奖方式': '抽奖方式',
  '指定弹幕': '指定弹幕',
  '指定礼物': '指定礼物',
  '礼物数量': '礼物数量',
  '抽取规则': '抽取规则',
  '面向用户': '面向用户',
  '等级要求': '等级要求',
  '注': '注',
  '主播不可参与抽奖': '主播不可参与抽奖',
  '抽奖活动是人人体育平台提供的直播间互动玩法。由平台提供奖品，粉丝通过发弹幕或送礼物参与抽奖': '抽奖活动是人人体育平台提供的直播间互动玩法。由平台提供奖品，粉丝通过发弹幕或送礼物参与抽奖',
  '平台每月提供定量的金币和兑换券，未消耗的奖品次月会自动清空': '平台每月提供定量的金币和兑换券，未消耗的奖品次月会自动清空',
  '兑换券自发放给用户之日起，有效期': '兑换券自发放给用户之日起，有效期',
  '月': '月',
  '日': '日',
  '奖品信息': '奖品信息',
  '参与时间': '参与时间',
  '最大为': '最大为',
  '注': '注',
  // 直播间榜单
  '主播未开通粉丝团～': '主播未开通粉丝团～',
  '送礼上榜提示': '送主播礼物，上{wordDeal}榜~',
  '送主播礼物，上{rank}榜~': '送主播礼物，上{rank}榜~',
  '按本周粉丝亲密值上升排行': '按本周粉丝亲密值上升排行',
  '周贡榜': '周贡榜',
  '总贡榜': '总贡榜',
  '粉丝榜': '粉丝榜',
  '周贡': '周贡',
  '总贡': '总贡',
  '粉丝': '粉丝',
  '进入直播间': '进入直播间',
  '弹幕': '弹幕',
  '精简': '精简',
  '华丽': '华丽',
  '弹幕小': '弹幕小',
  '弹幕中': '弹幕中',
  '弹幕大': '弹幕大',

}
